export interface Coordinates {
  latitude: number;
  longitude: number;
}

export const formatCoordinatesForInput = (coords: Coordinates | undefined): string => {
  if (!coords) return '';
  return `${coords.latitude}, ${coords.longitude}`;
};

export const parseCoordinatesFromInput = (coordsString: string): Coordinates | null => {
  if (!coordsString || typeof coordsString !== 'string') return null;

  const parts = coordsString.trim().split(',');

  if (parts.length !== 2) return null;

  const latitude = parseFloat(parts[0].trim());
  const longitude = parseFloat(parts[1].trim());

  if (isNaN(latitude) || isNaN(longitude)) return null;

  return { latitude, longitude };
};

export const validateCoordinatesFormat = (coords: string): boolean => {
  return parseCoordinatesFromInput(coords) !== null;
};
